import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, redirect, } from "react-router-dom";
import { JobBoard } from "./components/JobBoard";
import { getJobCategorySuids, normalizeJobCategorySuids, setJobCategorySuids, } from "./jobCategorySuids";
import { SearchParamType } from "./types/SearchParamType";
function hasJobBoardSearchParams(searchParams) {
    var keys = Array.from(searchParams.keys());
    var jobBoardParams = Object.values(SearchParamType).filter(function (key) { return key !== SearchParamType.JOB_CATEGORY_SUID; });
    return keys.some(function (key) { return jobBoardParams.includes(key); });
}
function haveSameValues(first, second) {
    return (first.length === second.length &&
        first.every(function (value, index) { return value === second[index]; }));
}
function createJobBoardLoader(filters) {
    var filterEntries = filters ? Array.from(filters) : [];
    return function (_a) {
        var request = _a.request;
        var url = new URL(request.url);
        var searchParams = url.searchParams;
        var originalSearch = searchParams.toString();
        var originalJobCategorySuids = searchParams.getAll(SearchParamType.JOB_CATEGORY_SUID);
        var jobCategorySuids = getJobCategorySuids(searchParams);
        if (!hasJobBoardSearchParams(searchParams) && filterEntries.length > 0) {
            filterEntries.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (key === SearchParamType.JOB_CATEGORY_SUID) {
                    jobCategorySuids.push.apply(jobCategorySuids, normalizeJobCategorySuids(typeof value === "string" ? [value] : value));
                }
                else {
                    if (typeof value !== "string") {
                        throw new TypeError("Filter ".concat(key, " only supports a scalar value."));
                    }
                    searchParams.set(key, value);
                }
            });
        }
        var mergedJobCategorySuids = normalizeJobCategorySuids(jobCategorySuids);
        if (!haveSameValues(originalJobCategorySuids, mergedJobCategorySuids)) {
            setJobCategorySuids(searchParams, mergedJobCategorySuids);
        }
        if (searchParams.toString() !== originalSearch) {
            return redirect("?".concat(searchParams.toString()));
        }
        return null;
    };
}
export function router(filters) {
    var mainRoute = [
        {
            path: "/",
            element: _jsx(JobBoard, {}),
            loader: createJobBoardLoader(filters),
        },
    ];
    return createBrowserRouter(mainRoute, { basename: window.location.pathname });
}
